var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73438 13V4.82422H0.191406V13H2.73438ZM1.44922 3.73047C2.26953 3.73047 2.92578 3.04688 2.92578 2.22656C2.92578 1.43359 2.26953 0.777344 1.44922 0.777344C0.65625 0.777344 0 1.43359 0 2.22656C0 3.04688 0.65625 3.73047 1.44922 3.73047ZM12.2227 13H12.25V8.51562C12.25 6.32812 11.7578 4.63281 9.1875 4.63281C7.95703 4.63281 7.13672 5.31641 6.78125 5.94531H6.75391V4.82422H4.32031V13H6.86328V8.95312C6.86328 7.88672 7.05469 6.875 8.36719 6.875C9.67969 6.875 9.70703 8.07812 9.70703 9.03516V13H12.2227Z",
    fill: "#0072B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial1);
export default __webpack_public_path__ + "static/media/social1.790e912c22149e060271a523e4bd8000.svg";
export { ForwardRef as ReactComponent };